import React from 'react';
import EmojiConvertor from 'emoji-js';

// Initialize emoji converter
const emoji = new EmojiConvertor();
emoji.replace_mode = 'unified'; // Use native Unicode emojis
emoji.allow_native = true;

/**
 * Formats a message with markdown and emoji support
 */
const MessageFormatter = ({ text }) => {
  if (!text) return null;

  // First, replace emoji codes using emoji-js
  let formattedText = emoji.replace_colons(text);

  // Split by lines to handle each line separately
  const lines = formattedText.split('\n');

  return (
    <div className="formatted-message">
      {lines.map((line, lineIndex) => {
        // Skip empty lines but add spacing
        if (line.trim() === '') {
          return <br key={lineIndex} />;
        }

        // Check if line is a separator (---)
        if (line.trim() === '---') {
          return <hr key={lineIndex} className="message-separator" />;
        }

        // Parse the line for markdown formatting
        const parts = [];
        let currentIndex = 0;
        let partKey = 0;

        // Regular expression to match bold text (*text*)
        const boldRegex = /\*([^*]+)\*/g;
        let match;

        let lastIndex = 0;
        const matches = [];

        // Find all bold matches
        while ((match = boldRegex.exec(line)) !== null) {
          matches.push({
            start: match.index,
            end: match.index + match[0].length,
            text: match[1],
            type: 'bold',
          });
        }

        // Build the line with formatting
        if (matches.length === 0) {
          // No formatting, just return the line
          return (
            <div key={lineIndex} className="message-line">
              {line}
            </div>
          );
        }

        // Process matches
        lastIndex = 0;
        matches.forEach((match, matchIndex) => {
          // Add text before the match
          if (match.start > lastIndex) {
            parts.push(
              <span key={`text-${partKey++}`}>
                {line.substring(lastIndex, match.start)}
              </span>
            );
          }

          // Add the bold text
          parts.push(
            <strong 
              key={`bold-${partKey++}`} 
              className="message-bold"
              style={{ fontFamily: 'ArtifaktElement-Bold, sans-serif' }}
            >
              {match.text}
            </strong>
          );

          lastIndex = match.end;
        });

        // Add remaining text after last match
        if (lastIndex < line.length) {
          parts.push(
            <span key={`text-${partKey++}`}>{line.substring(lastIndex)}</span>
          );
        }

        return (
          <div key={lineIndex} className="message-line">
            {parts}
          </div>
        );
      })}
    </div>
  );
};

export default MessageFormatter;

